import React, { useEffect, useState } from "react";
import { useDialog } from "../../../hooks/useDialog";
import { Dialog } from "../../Dialog/Dialog";
import { Button, makeStyles } from "@material-ui/core";
import { ChartModule } from "./ChartModule";
import ShowChartIcon from "@material-ui/icons/ShowChart";

const style = makeStyles((theme) => ({
  chartButton: {
    color: "#BB8906",
    border: "2px solid #BB8906",
    width: "400px",
    marginBottom: "2px",
    display: "flex",
    justifyContent: "space-between",
  },
  icon: {
    width: "30px",
    height: "30px",
  },
}));

export const ChartFieldConstructorUser = (props) => {
  const { content, variable, value, setFieldValue, label } = props;

  const usestyle = style();
  const ChartDialog = useDialog();
  const DataDialog = useDialog();

  const [data, setData] = useState(value ? value.data : []);
  const [line, setLine] = useState(value ? value.line : []);
  const [dataTable, setDataTable] = useState([]);
  const [nameLine, setNameLine] = useState();

  let fakeLine = {
    type: "basis",
    dataKey: `График - ${line.length + 1}`,
    stroke: "#000000",
  };


  const [makeLine, setMakeLine] = useState(fakeLine);

  const submitChart = () => {
    setFieldValue(variable, {
      ...value,
      data: data,
      line: line,
    });
  };

  const hendleMutateData = (dataKey) => {
    setNameLine(dataKey);
    DataDialog.handleOpen();
    setDataTable(() => {
      return data.filter((dot) => dot[dataKey] !== undefined);
    });
  };

  const handleOpenChartDialog = () => ChartDialog.handleOpen();

  return (
    <React.Fragment>
      <Dialog
        open={ChartDialog.open}
        handleClose={() => {
          ChartDialog.handleClose();
        }}
        actions={
          <Button
            onClick={() => {
              submitChart();
              ChartDialog.handleClose();
            }}
          >
            Сохранить
          </Button>
        }
        maxWidth={"lg"}
        fullWidth={true}
      >
        <div style={{ margin: "20px" }}>
          <ChartModule
            initialValue={content.initialValue}
            makeLine={makeLine}
            data={data}
            line={line}
            setMakeLine={setMakeLine}
            setData={setData}
            setLine={setLine}
            label={label}
            hendleMutateData={hendleMutateData}
            handleCloseDataDialog={DataDialog.handleClose}
            openDataDialog={DataDialog.open}
            dataTable={dataTable}
            nameLine={nameLine}
            setDataTable={setDataTable}
            setFieldValue={setFieldValue}
            variable={variable}
            value={value}
          />
        </div>
      </Dialog>
      <Button
        className={usestyle.chartButton}
        variant="outlined"
        onClick={handleOpenChartDialog}
      >
        {label}
        <ShowChartIcon className={usestyle.icon} />
      </Button>
    </React.Fragment>
  );
};
